import { JwtCliengoPayload } from '../types';

import { parseJwtCliengo } from './jwt-parser';

/**
 * Validates the authenticity of a Cliengo JWT trying to get the websites.
 * @param jwt the JWT set in the Cookies
 * @param onAuthenticationVerified a Callback to call if the token is correct
 * @returns true in case the token is correct
 */
export function verifyAuthToken(
  jwt: string,
  onAuthenticationVerified: (jwt: string, isAdmin: boolean) => void
): boolean {
  try {
    const payload: JwtCliengoPayload | undefined = parseJwtCliengo(jwt);

    if (payload) {
      onAuthenticationVerified(
        jwt,
        payload.privileges.includes('admin') ||
          payload.privileges.includes('superadmin')
      );
      return true;
    }
  } catch (e) {}
  return false;
}
